var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer"
  }, [_vm.social && _vm.social.icons ? _c('div', {
    staticClass: "icons"
  }, _vm._l(_vm.social.icons, function (item, index) {
    return _c('a', {
      key: index,
      class: ['iconfont', item.iconClass],
      attrs: {
        "href": item.link,
        "title": item.title,
        "target": "_blank"
      }
    });
  }), 0) : _vm._e(), _vm._v(" "), _vm._v("\n  Theme by\n  "), _c('a', {
    attrs: {
      "href": "https://github.com/xugaoyi/vuepress-theme-vdoing",
      "target": "_blank",
      "title": "本站主题"
    }
  }, [_vm._v("Vdoing")]), _vm._v(" "), _vm.footer ? [_vm._v("\n    | Copyright © " + _vm._s(_vm.footer.createYear) + "-" + _vm._s(new Date().getFullYear()) + "\n    "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.footer.copyrightInfo)
    }
  })] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };